import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { PoliciesFailure, PoliciesRequest, PoliciesSuccess } from './actions';
import { PoliciesService } from './service';

@Injectable()
export class PoliciesEffects {
  private readonly actions$ = inject(Actions);
  private readonly policiesService = inject(PoliciesService);

  policies$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PoliciesRequest),
      switchMap(({ parameters }) =>
        this.policiesService.policies(parameters).pipe(
          map(data => PoliciesSuccess({ data })),
          catchError(error => of(PoliciesFailure({ error })))
        )
      )
    )
  );

}
